import { render, staticRenderFns } from "./testing-playground.vue?vue&type=template&id=987043ee"
import script from "./testing-playground.vue?vue&type=script&lang=js"
export * from "./testing-playground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports